/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
// import 'date-fns';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
import Loader from '../../Loader';
// import Typography from '@material-ui/core/Typography';
// import withStyles from '@material-ui/core/styles/withStyles';
// import MomentUtils from '@date-io/moment';
// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker,
//   DatePicker,
// } from '@material-ui/pickers';
// import Slider from '@material-ui/core/Slider';
import useDebounce from '../../../utils/useDebounce';

const Toolbar = (props) => {
  const {
    active,
    setActive,
    payed,
    setPayed,
    // renewSubscription,
    // setRenewSubscription,
    // couponCode,
    setCouponCode,
    // userId,
    // setUserId,
    email,
    setEmail,
    name,
    setName,
    present,
    // setPresent,
    // productSlugName,
    setProductSlugName,
    setCouponTypeId,
    setSubscriptionStatus,
    productList,
    couponTypesList,
    // setProductGroup,
    // productType,
    setProductType,
    // provider,
    setProvider,
    startDate,
    setStartDate,
    finishDate,
    setFinishDate,
    setCountry,
    handleDownload,
    handleDownloadAll,
    downloadingInProgress,
    downloadingAllInProgress,
  } = props;
  const [productListOptions, setProductListOptions] = useState([]);
  const className = {};

  useEffect(() => {
    const options = productList.map((productOption) => {
      const {
        slugName, title,
      } = productOption;
      const option = (
        <option key={slugName} value={slugName}>
          {title.es}
        </option>
      );
      return option;
    });
    setProductListOptions(options);
  }, [productList]);

  const getCouponTypeOptionList = () => {
    if (!couponTypesList) [];
    return couponTypesList.map((couponTypeOption) => {
      const {
        couponTypeId, couponName,
      } = couponTypeOption;
      const option = (
        <option key={couponTypeId} value={couponTypeId}>
          {couponName}
        </option>
      );
      return option;
    });
  };

  const setActiveState = (value) => {
    setActive(value);
    if (value && payed === '2') {
      // Remove incompatible filter value
      setPayed(0);
    }
  };

  const setPayedState = (value) => {
    setPayed(value);
    if (active && value === '2') {
      // Remove incompatible filter value
      setActive(null);
    }
  };

  // Initialize local state with values from shared filters (URL params)
  const [emailSearch, setEmailSearch] = useState(email || '');
  const debouncedEmail = useDebounce(emailSearch, 500);

  // Sync local state with URL params when they change (e.g., when switching tabs)
  useEffect(() => {
    setEmailSearch(email || '');
  }, [email]);

  useEffect(() => {
    setEmail(emailSearch || null);
  }, [debouncedEmail]);

  // Initialize local state with values from shared filters (URL params)
  const [nameSearch, setNameSearch] = useState(name || '');
  const debouncedName = useDebounce(nameSearch, 500);

  // Sync local state with URL params when they change
  useEffect(() => {
    setNameSearch(name || '');
  }, [name]);

  useEffect(() => {
    setName(nameSearch || null);
  }, [debouncedName]);

  const [countrySearch, setCountrySearch] = useState('');
  const debouncedCountry = useDebounce(countrySearch, 500);
  useEffect(() => {
    setCountry(countrySearch);
  }, [debouncedCountry]);

  const [couponCodeSearch, setCouponCodeSearch] = useState('');
  const debouncedCouponCode = useDebounce(couponCodeSearch, 500);
  useEffect(() => {
    setCouponCode(couponCodeSearch);
  }, [debouncedCouponCode]);

  // Initialize local state with values from shared filters (URL params)
  const [startDateSearch, setStartDateSearch] = useState(startDate || '');
  const debouncedStartDate = useDebounce(startDateSearch, 500);

  // Sync local state with URL params when they change
  useEffect(() => {
    setStartDateSearch(startDate || '');
  }, [startDate]);

  useEffect(() => {
    const date = new Date(new Date(startDateSearch).toDateString());
    if (startDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setStartDate(startDateSearch || null);
    }
  }, [debouncedStartDate]);

  // Initialize local state with values from shared filters (URL params)
  const [finishDateSearch, setFinishDateSearch] = useState(finishDate || '');
  const debouncedFinalDate = useDebounce(finishDateSearch, 500);

  // Sync local state with URL params when they change
  useEffect(() => {
    setFinishDateSearch(finishDate || '');
  }, [finishDate]);

  useEffect(() => {
    const date = new Date(new Date(finishDateSearch).toDateString());
    if (finishDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setFinishDate(finishDateSearch || null);
    }
  }, [debouncedFinalDate]);

  // const handleChangeRange = (event, newValue) => {
  //   rangeSetValue(newValue);
  // };
  // const setRangeFilter = (event, newValue) => {
  //   setPriceFilter(newValue);
  // };

  // flex-wrap + flex-no-shrink: in one non-wrapping row the selects shrank to their padding
  // (48px), so the selected option was invisible. Coupon Type is capped, its options are long.
  return (
    <div className="flex flex-wrap">
      <div className="flex w-1/6 my-6 items-center">
        <label htmlFor="toggle" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Only active subscriptions</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            value={active}
            onChange={() => setActiveState(!active)}
            checked={active}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="toggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer" />
        </div>
      </div>

      <div className="px-3 md:mb-0 flex-no-shrink">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Payed
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            value={payed}
            onChange={e => setPayedState(e.target.value)}
          >
            <option value="0" />
            <option value="1">Success</option>
            <option value="2">Failed</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="px-3 md:mb-0 flex-no-shrink">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Status
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={newValue => setSubscriptionStatus(newValue.currentTarget.value)}
          >
            <option value="" />
            <option value="new">New</option>
            <option value="renewed">Renewed</option>
            <option value="notRenewed">Not Renewed</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      {/* <div className="px-3 md:mb-0">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Product Type
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            value={payed}
            onChange={e => setProductType(e.target.value)}
          >
            <option value="" />
            <option value="subscription">Subscription</option>
            <option value="present">Present</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div> */}


      <div className="px-3 md:mb-0 flex-no-shrink">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Product
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={newValue => setProductSlugName(newValue.currentTarget.value)}
          >
            <option value="" />
            {productListOptions}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="px-3 md:mb-0 flex-no-shrink max-w-xs">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Coupon Type
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={newValue => setCouponTypeId(newValue.currentTarget.value)}
          >
            <option value="" />
            {getCouponTypeOptionList()}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="px-3 md:mb-0 flex-no-shrink">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Provider
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={newValue => setProvider(newValue.currentTarget.value)}
          >
            <option value="" />
            <option value="stripe">Stripe</option>
            <option value="paypal">Paypal</option>
            <option value="free">Free</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="w-1/6 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="emailSearch"
        >
          Email
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="emailSearch"
          type="text"
          onChange={e => setEmailSearch(e.target.value)}
          value={emailSearch}
        />
      </div>

      <div className="w-1/6 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="nameSearch"
        >
          Name
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="nameSearch"
          type="text"
          onChange={e => setNameSearch(e.target.value)}
          value={nameSearch}
        />
      </div>

      <div className="w-1/6 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="countrySearch"
        >
          Country
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="countrySearch"
          type="text"
          onChange={e => setCountrySearch(e.target.value)}
          value={countrySearch}
        />
      </div>

      <div className="w-1/6 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="couponCodeSearch"
        >
          Coupon
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="couponCodeSearch"
          type="text"
          onChange={e => setCouponCodeSearch(e.target.value)}
          value={couponCodeSearch}
        />
      </div>


      <div className="w-1/6 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="startDateSearch"
        >
          Start Date
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="startDateSearch"
          placeholder="yyyy-mm-dd"
          type="text"
          onChange={e => setStartDateSearch(e.target.value)}
          value={startDateSearch}
        />
      </div>

      <div className="w-1/6 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="finishDateSearch"
        >
          Final Date
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="finishDateSearch"
          placeholder="yyyy-mm-dd"
          type="text"
          onChange={e => setFinishDateSearch(e.target.value)}
          value={finishDateSearch}
        />
      </div>

      <div className="px-3 md:mb-0">
        <div className="mb-2">
          &nbsp;
        </div>
        <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="download" onClick={handleDownload}>
          {!downloadingInProgress && 'Download filtered'}
          {downloadingInProgress && <Loader type="TailSpin" color="#000" height="20" width="20" />}
        </button>
      </div>

      <div className="px-3 md:mb-0">
        <div className="mb-2">
          &nbsp;
        </div>
        <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="download" onClick={handleDownloadAll}>
          {!downloadingAllInProgress && 'Download all'}
          {downloadingAllInProgress && <Loader type="TailSpin" color="#000" height="20" width="20" />}
        </button>
      </div>

      {/* <Grid
        className={classes.range}
        item
        lg={3}
        sm={6}
        xl={3}
        xs={12}
        m={2}
      >
        <Typography id="range-slider">
          Order price range
        </Typography>
        <Slider
          value={rangeValue}
          onChange={handleChangeRange}
          onChangeCommitted={setRangeFilter}
          aria-labelledby="range-slider"
          valueLabelDisplay="auto"
          min={0}
          max={2000}
        />
      </Grid> */}
    </div>
  );
};

Toolbar.propTypes = {
  active: PropTypes.bool,
  setActive: PropTypes.func.isRequired,
  payed: PropTypes.bool,
  setPayed: PropTypes.func.isRequired,
  // renewSubscription: PropTypes.bool,
  // setRenewSubscription: PropTypes.func.isRequired,
  // couponCode: PropTypes.string,
  setCouponCode: PropTypes.func.isRequired,
  // userId: PropTypes.string,
  // setUserId: PropTypes.func.isRequired,
  email: PropTypes.string,
  setEmail: PropTypes.func.isRequired,
  name: PropTypes.string,
  setName: PropTypes.func.isRequired,
  // present: PropTypes.bool,
  // setPresent: PropTypes.func.isRequired,
  // productSlugName: PropTypes.string,
  setProductSlugName: PropTypes.func.isRequired,
  setCouponTypeId: PropTypes.func.isRequired,
  productList: PropTypes.arrayOf(PropTypes.object),
  // setProductGroup: PropTypes.func.isRequired,
  // productType: PropTypes.string,
  setProductType: PropTypes.func.isRequired,
  // provider: PropTypes.string,
  setProvider: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  setStartDate: PropTypes.func.isRequired,
  finishDate: PropTypes.string,
  setFinishDate: PropTypes.func.isRequired,
  // country: PropTypes.string,
  setCountry: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  handleDownloadAll: PropTypes.func.isRequired,
  downloadingInProgress: PropTypes.bool.isRequired,
  downloadingAllInProgress: PropTypes.bool.isRequired,
};

Toolbar.defaultProps = {
  active: null,
  payed: null,
  // renewSubscription: null,
  // couponCode: null,
  // userId: null,
  email: null,
  name: null,
  // present: null,
  // productSlugName: null,
  productList: null,
  // productType: null,
  // provider: null,
  startDate: null,
  finishDate: null,
};

export default Toolbar;
